import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

interface UseValidateURLOptions {
    disallowList?: string[];
    pattern?: RegExp;
}

export const useValidateURL = (options?: UseValidateURLOptions) => {
    // 只允許小寫字母、數字、-
    const { disallowList = ["index", "admin"], pattern = /^[a-z0-9-]+$/ } = options || {};
    const { t } = useTranslation();
    const [customUrlInput, setCustomUrlInput] = useState<string>("");
    const [urlError, setUrlError] = useState<string | null>(null);

    const validateUrl = useCallback(
        (url: string) => {
            const trimmedUrl= url?.trim?.() || "";
            // 不允許空白或間隔
            if (!trimmedUrl) {
                setUrlError(t("WEBWIDGET.URL_NAME_EMPTY") || "");
                return false;
            }

            const lower = trimmedUrl.toLowerCase();
            if (disallowList.includes(lower)) {
                setUrlError(t("WEBWIDGET.URL_NAME_RESTRICTED") || "");
                return false;
            }

            if (/\s/.test(trimmedUrl)) {
                setUrlError(t("WEBWIDGET.URL_NAME_FORMAT") || "");
                return false;
            }

            if (trimmedUrl !== trimmedUrl.toLowerCase()) {
                setUrlError(t("WEBWIDGET.URL_NAME_FORMAT") || "");
                return false;
            }

            if (!pattern.test(trimmedUrl)) {
                setUrlError(t("WEBWIDGET.URL_NAME_FORMAT") || "");
                return false;
            }

            setUrlError("");
            return true;
        },
        [disallowList, pattern, t]
    );

    const handleUrlChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const newUrl = e.target.value;
            setCustomUrlInput(newUrl);
            if (newUrl) {
                validateUrl(newUrl);
            } else {
                setUrlError("");
            }
        },
        [validateUrl]
    );

    const clearError = useCallback(() => setUrlError(""), []);

    return {
        customUrlInput,
        setCustomUrlInput,
        urlError,
        handleUrlChange,
        clearError,
    };
};


